import Swiper from 'swiper';

export default function homeSliderInit() {

    let homeSlider = this,
        $widgets = $('[data-widget-homeslider]'),
        widgets = [],
        classes = {
            moving: 'home-slider--moving',
            contentFade: '_content-fade',
            contentDelay: '_content-delay',
            slidePrevious: 'swiper-slide--previous',
            slideBetween: 'swiper-slide--between',
            slideBeforePrevious: 'swiper-slide--before-previous',
            slideActive: 'swiper-slide--active',
            SliderActivePrimary: 'home-slider--active-primary'
        };

    if ($widgets.length === 0) {
        return false;
    }

    $widgets.each(function (index, element) {
        let $widget = $(element),
            $slider = $('.swiper-container', $widget);
        widgets.push({});
        widgets[index].widget = $widget;
        widgets[index].initialized = false;
        widgets[index].progress = [0, 0];
        widgets[index].transition = 0;
        widgets[index].slider = new Swiper($slider, {
            speed: 1000,
            slidesPerView: 1,
            // slidesOffsetBefore: 80,
            // slidesOffsetAfter: 80,
            // spaceBetween: 20,
            autoplay: {
                delay: 7000,
                waitForTransition: false,
                disableOnInteraction: false
            },
            virtualTranslate: true,
            allowTouchMove: false,
            pagination: {
                el: '.home-slider__pagination',
                type: 'bullets',
                bulletClass: 'home-slider__pagination-item',
                bulletActiveClass: 'home-slider__pagination-item--active',
                clickable: true,
                renderBullet: function (index, className) {
                    // console.log(index, className);
                    let bulletContent = index + 1;
                    if (bulletContent < 10) {
                        bulletContent = '0' + bulletContent;
                    }
                    return `<div class="${className}">
<div class="${className + '-progress'}"></div>
<div class="${className + '-text'}">${bulletContent}</div>
</div>`;
                }
            },
            breakpoints: {
                767: {
                    virtualTranslate: false,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    spaceBetween: 0,
                    slidesPerView: 1
                },
                1199: {
                    virtualTranslate: true
                }
            },
            on: {
                init: handlerInit,
                slideChange: handlerSlideChange,
                // transitionStart: handlerTransitionStart,
                // slideChangeTransitionStart: handlerSlideChangeTransitionStart,
                autoplayStart: handlerAutoplayStart,
                autoplayStop: handlerAutoplayStop,
                // reachEnd: handlerReachEnd,
                // fromEdge: handlerFromEdge
            }
        });
    });

    // handlers

    function handlerInit(widget) {
        sliderSetContent(this);
        // console.log('init');
    }

    function delayClassesIndexChange(slide) {
        setTimeout(() => {
            slide.classList.remove(classes.slidePrevious);
            slide.classList.add(classes.slideActive);
        }, 10);
    }

    function delayClassIndexChange(slide) {
        setTimeout(() => {
            slide.classList.add(classes.slideActive);
        }, 10);
    }

    function handlerSlideChange() {
        // console.log('handlerSlideChange');
        let swiper = this,
            previousIndex = swiper.previousIndex,
            activeIndex = swiper.isEnd ? swiper.slides.length - 1 : swiper.activeIndex;
        sliderSetContent(swiper);
        //console.log(swiper.previousIndex, swiper.activeIndex, swiper.activeIndex, swiper.progress, swiper.isEnd);
        if (previousIndex < activeIndex) {
            // console.log('forward', previousIndex, activeIndex);
            for (let i = 0; i< swiper.slides.length; i++) {
                let slide = swiper.slides[i],
                    slideIndex = i;

                if (slideIndex < previousIndex) {
                    slide.classList.add(classes.slideBeforePrevious);
                }
                else {
                    slide.classList.remove(classes.slideBeforePrevious);
                }

                if (slideIndex === previousIndex) {
                    slide.classList.add(classes.slidePrevious);
                }
                else {
                    slide.classList.remove(classes.slidePrevious);
                }

                if (slideIndex < activeIndex && slideIndex > previousIndex) {
                    slide.classList.add(classes.slideBetween);
                }
                else {
                    slide.classList.remove(classes.slideBetween);
                }

                if (slideIndex === activeIndex) {
                    slide.classList.remove(classes.slideBetween);
                    delayClassIndexChange(slide);
                    // setTimeout(() => {
                    //     slide.classList.add(classes.slideActive);
                    // }, 10);
                }
                else {
                    slide.classList.remove(classes.slideActive);
                }
            }
        }
        else if (previousIndex > activeIndex) {
            // console.log('backward', previousIndex, activeIndex);
            for (let i = 0; i< swiper.slides.length; i++) {
                let slide = swiper.slides[i],
                    slideIndex = i;

                if (slideIndex === activeIndex) {
                    slide.classList.add(classes.slidePrevious);
                    slide.classList.remove(classes.slideBeforePrevious, classes.slideBetween);
                    delayClassesIndexChange(slide);
                    // setTimeout(() => {
                    //     slide.classList.remove(classes.slidePrevious);
                    //     slide.classList.add(classes.slideActive);
                    // }, 10);
                }

                if (slideIndex === previousIndex) {
                    slide.classList.remove(classes.slideBeforePrevious, classes.slidePrevious, classes.slideBetween, classes.slideActive);
                }

                if (slideIndex > activeIndex && slideIndex < previousIndex) {
                    slide.classList.remove(classes.slideBeforePrevious, classes.slidePrevious, classes.slideActive);
                    slide.classList.add(classes.slideBetween);
                }

                /*if (slideIndex < activeIndex && slideIndex > previousIndex) {
                    slide.classList.add(classes.slideBetween);
                }
                else {
                    slide.classList.remove(classes.slideBetween);
                }

                if (slideIndex === activeIndex) {
                    slide.classList.add(classes.slideActive);
                }
                else {
                    slide.classList.remove(classes.slideActive);
                }*/
            }
        }
        /*swiper.slides.forEach(function (slide, slideIndex, array) {
            if (slideIndex === previousIndex) {
                slide.classList.add(classes.slidePrevious);
            }
            if (slideIndex < activeIndex && slideIndex > previousIndex) {
                slide.classList.add(classes.slideBetween);
            }
            if (slideIndex === activeIndex) {
                slide.classList.add(classes.slideActive);
            }
        });*/
    }

    function handlerSlideChangeTransitionStart() {
        // console.log('handlerSlideChangeTransitionStart');
    }

    function handlerNextTransitionStart(widget) {
    }

    function handlerTransitionStart() {
        // console.log('handlerTransitionStart');
        // sliderSetContent(this);
        /*let swiper = this;

        console.log(swiper.activeIndex, swiper.progress, swiper.isEnd);*/
    }

    function handlerTransitionEnd(widget) {
    }

    function handlerProgress(widget, progress) {
    }

    function handlerTranslate(widget, translate) {
    }

    function handlerAutoplayStart(a, b, c) {
        console.log('autoplay start');
        setTimeout (() => {
            this.$wrapperEl.parents('[data-widget-homeslider]').toggleClass('_inited', true);
            this.$wrapperEl.parents('[data-widget-homeslider]').toggleClass('_uninited', false);
        }, 20);
    }

    function handlerAutoplayStop(a, b, c) {
        // console.log('autoplay stop');
    }

    function handlerReachEnd(a, b, c) {
        // console.log('handlerReachEnd');
    }

    function handlerFromEdge(a, b, c) {
        // console.log('handlerFromEdge');
    }

    // utils

    function sliderSetContent(swiper) {
        let $slideActive = !swiper.isEnd ? $(swiper.slides[swiper.activeIndex], swiper.$wrapperEl) : $(swiper.slides[swiper.slides.length - 1], swiper.$wrapperEl),
            activePrimary = $('.homescreen--primary', $slideActive).length > 0,
            $slider = $slideActive.parents('.home-slider'),
            $contentSource = $('.home-slider__content-holder', $slideActive),
            $contentTarget = $('[data-widget-homeslider-target]'),
            $heading = $('.homescreen__heading', $contentTarget),
            $subheading = $('.homescreen__subheading', $contentTarget),
            $controls = $('.homescreen__controls', $contentTarget),
            heading = $contentSource.data('content-heading'),
            subheading = $contentSource.data('content-subheading'),
            buttonUrl = $contentSource.data('content-url'),
            buttonText = $contentSource.data('content-btn'),
            $btn = $('.homescreen__controls .btn', $contentTarget),
            $btnText = $('.homescreen__controls .btn-caption', $contentTarget);

        if (activePrimary) {
            $slider.toggleClass(classes.SliderActivePrimary, true);
        }
        else {
            $slider.toggleClass(classes.SliderActivePrimary, false);
        }

        if(buttonUrl.length === 0 || buttonText.length === 0) {
            $controls.toggleClass('_fade', true);
        }

        if ($contentTarget.hasClass(classes.contentFade)) {
            $contentTarget.toggleClass(classes.contentDelay, true);
            $contentTarget.toggleClass(classes.contentFade, false);
            $heading.text(heading);
            if (activePrimary) {
                $subheading.text(subheading);
            }
            else {
                $subheading.text('');
            }
            $btn.attr('href', buttonUrl);
            $btnText.text(buttonText);
            if(buttonUrl.length > 0 && buttonText.length > 0) {
                $controls.toggleClass('_fade', false);
            }
        }
        else {
            $contentTarget.toggleClass(classes.contentDelay, false);
            $contentTarget.toggleClass(classes.contentFade, true);

            $contentTarget.one('transitionend', (event) => {
                $contentTarget.toggleClass(classes.contentFade, false);
                $heading.text(heading);
                if (activePrimary) {
                    $subheading.text(subheading);
                }
                else {
                    $subheading.text('');
                }
                $btn.attr('href', buttonUrl);
                $btnText.text(buttonText);
                if(buttonUrl.length > 0 && buttonText.length > 0) {
                    $controls.toggleClass('_fade', false);
                }
            });
        }
    }

    function setSlideStatus(widget) {
        //$widget.toggleClass(classes.moving, true);
    }

    function setSlideProgress(widget, direction, slider) {
    }

    function setSlideOffset(widget, direction) {
    }

    window.widgets = widgets;

    return null;
}